export function toUser(userData) {
  /**
   * User
   * {String} userName
   * {String} email
   */
  return {
    userName: userData.user_name,
    email: userData.email
  };
}
export function toTeamMember(teamMemberData) {
  return {
    userId: teamMemberData.user_id,
    firstName: teamMemberData.first_name,
    lastName: teamMemberData.last_name,
    email: teamMemberData.email,
    img: teamMemberData.img,
    isAccountOwner: teamMemberData.is_account_owner,
    roles: teamMemberData.roles,
    joinedAt: teamMemberData.joined_at
  };
}
export function toTeam(teamData) {
  return {
    ownerId: teamData.owner_id,
    members: teamData.members.map(toTeamMember)
  };
}
export function toSitesInfo(sitesInfoData) {
  return {
    sitesNumber: sitesInfoData.sites_number,
    hasVisitorUploads: sitesInfoData.has_visitor_uploads,
    hasContributors: sitesInfoData.has_contributors,
    team: toTeam(sitesInfoData.team)
  };
}
export function toManagerInfo(sitesInfoData) {
  return {
    hasOldMedia: sitesInfoData.has_media,
    hasSiteMedia: sitesInfoData.has_site_media,
    migrationStatus: sitesInfoData.migration_status,
    hasVisitorUploads: sitesInfoData.has_visitor_uploads
  };
}